import React from 'react';
import cn from 'classnames';
import './Button.css';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'text' | 'outlined' | 'solid';
};

export const Button = ({
  disabled,
  className,
  variant = 'solid',
  children,
  ...buttonProps
}: ButtonProps): JSX.Element => {
  return (
    <button
      className={
        cn(className, variant, {
          disabled,
        }) + ' landing_button'
      }
      {...buttonProps}
    >
      <span>{children}</span>
    </button>
  );
};
